var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 115,
    viewBox: "0 0 33 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2183_9551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06817 94.1117C4.06817 93.0691 3.15679 92.2228 2.03408 92.2228C0.911375 92.2228 -5.30931e-07 93.0691 -4.82457e-07 94.1117L-8.66826e-08 102.624C-3.87791e-08 103.654 0.911376 104.488 2.03408 104.488L18.9936 104.488C20.1229 104.488 21.0012 103.666 21.0012 102.624C21.0012 101.581 20.1031 100.735 18.9936 100.735L12.6074 100.735L12.6074 94.1117C12.6074 93.0691 11.7092 92.2228 10.5997 92.2228C9.45716 92.2228 8.5656 93.0507 8.5656 94.1117L8.5656 100.735L4.08138 100.735L4.08138 94.1117L4.06817 94.1117Z",
    fill: "#FFE227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.128906 80.0296C0.128906 85.4142 4.83106 89.793 10.6163 89.793C16.4148 89.793 21.1301 85.4142 21.1301 80.0296C21.1301 74.6574 16.428 70.2908 10.6427 70.2908C4.84428 70.2908 0.128906 74.6574 0.128906 80.0296ZM17.029 80.0296C17.029 83.3168 14.1495 85.9907 10.6097 85.9907C7.08969 85.9907 4.22349 83.3168 4.22349 80.0296C4.22349 76.7609 7.08969 74.0993 10.6097 74.0993C14.1495 74.0993 17.029 76.7609 17.029 80.0296Z",
    fill: "#FFE227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.128906 57.9906C0.128906 63.3751 4.83106 67.7539 10.6163 67.7539C16.4148 67.7539 21.1301 63.3751 21.1301 57.9906C21.1301 52.6183 16.428 48.2518 10.6427 48.2518C4.84428 48.2518 0.128906 52.6183 0.128906 57.9906ZM17.029 57.9906C17.029 61.2777 14.1495 63.9516 10.6097 63.9516C7.08969 63.9516 4.22349 61.2777 4.22349 57.9906C4.22349 54.7218 7.08969 52.0602 10.6097 52.0602C14.1495 52.0541 17.029 54.7157 17.029 57.9906Z",
    fill: "#FFE227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0332028 37.724L0.033203 41.5877C0.0332031 42.6486 0.918167 43.4766 2.04087 43.4766L18.8088 43.4766C19.9316 43.4766 20.8363 42.6732 20.8693 41.649L21.0278 37.7731L21.0278 37.724C21.0278 32.3395 16.3125 27.9607 10.514 27.9607C4.74197 27.9607 0.0332026 32.3395 0.0332028 37.724ZM16.9399 37.6873L16.8738 39.6988L4.10797 39.6988L4.10797 37.724C4.10797 34.4246 6.98739 31.7385 10.5272 31.7385C14.0671 31.7385 16.9399 34.4124 16.9399 37.6873Z",
    fill: "#FFE227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.128906 12.6234C0.128906 18.0079 4.83106 22.3867 10.6163 22.3867C16.4148 22.3867 21.1301 18.0079 21.1301 12.6234C21.1301 7.25111 16.428 2.88459 10.6427 2.88459C4.84428 2.88459 0.128906 7.25111 0.128906 12.6234ZM17.029 12.6234C17.029 15.9105 14.1495 18.5844 10.6097 18.5844C7.08969 18.5844 4.22349 15.9105 4.22349 12.6234C4.22349 9.35464 7.08969 6.69302 10.6097 6.69302C14.1495 6.68689 17.029 9.3485 17.029 12.6234Z",
    fill: "#FFE227"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2183_9551",
    x: 0,
    y: 0.882812,
    width: 33.1304,
    height: 113.605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2183_9551"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2183_9551",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodo);
export default __webpack_public_path__ + "static/media/foodo.2511544ce095e38b4492a62ebf6945dc.svg";
export { ForwardRef as ReactComponent };